import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Envío de eventos a Google Tag Manager (dataLayer.push).
 *
 * TODO: CONFIGURAR EN PROYECTO DESTINO — este servicio NO carga el snippet de GTM
 * (eso vive en index.html, fuera del alcance de una feature portable, ver Regla
 * Crítica #13/#15 del encargo). Asume que el proyecto anfitrión ya tiene GTM
 * cargado globalmente y `window.dataLayer` disponible; si el contenedor GTM
 * original de esta landing (GTM-5SKX6DR) debe usarse, el proyecto destino debe
 * incorporarlo en su propio index.html.
 */
@Injectable()
export class LandingAnalyticsService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  trackEvent(event: string, payload: Record<string, unknown> = {}): void {
    if (!this.isBrowser) {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  }
}
